__webpack_require__.p = "/reports-dashboard-templates-rename-sidebar/account-setup/";